import React from 'react';
import {
	Container,
	ContainerGutter,
	List,
	ListGutter,
	ListItem,
	Text,
	TokenTextAppearance,
} from '@volkswagen-onehub/components-core';
import { ServiceLayer } from '../services-layer-types';

export const serviciosTallerLayer: ServiceLayer = {
	header: 'Servicios del taller',
	title: 'Autoservicio',
	subtitle: (
		<Text appearance={TokenTextAppearance.copy200}>
			No siempre es fácil encontrar hueco de lunes a viernes para pasar por el taller. Por suerte, con este servicio
			podrás acercarte cuando quieras a recoger o dejar tu Volkswagen. Solo tienes que guardar la llave en la taquilla.
		</Text>
	),
	description: (
		<Container wrap="always" gutter={ContainerGutter.dynamic0100}>
			<Text appearance={TokenTextAppearance.headline200} bold>
				Ventajas de este servicio:
			</Text>
			<Text appearance={TokenTextAppearance.copy200}>
				<List gutter={ListGutter.dynamic0020}>
					<ListItem>
						Es seguro: las taquilla están blindadas, protegidas y monitorizadas. Solo tú podrás acceder con un código
						único.
					</ListItem>
					<ListItem>Es flexible: tú eliges cuándo pasar a por tu Volkswagen, sin contacto y sin esperas.</ListItem>
					<ListItem>
						Es digital: todo lo podrás hacer con tu móvil, desde pedir cita hasta pagar online. Este sistema es cómodo y
						fácil de usar.
					</ListItem>
				</List>
			</Text>
		</Container>
	),
	imageContent:
		'https://assets.volkswagen.com/is/image/volkswagenag/layer-autoservicio?Zml0PWNyb3AlMkMxJndpZD04OTYmaGVpPTg5NiZmbXQ9anBlZyZxbHQ9NzkmYmZjPW9mZiZlMmRh',
};
